/**
 * Функция фиксации хедера
 */
$.fn.fixedHeader = function() {
    const $self = $(this);
    const headerBottomPosition = $self.innerHeight() + $self.offset().top;

    $(document).on('scroll', function () {
        if ($(window).scrollTop() > headerBottomPosition) {
            $self.addClass('fixed');
        } else {
            $self.removeClass('fixed');
        }
    })
};
